import axios from 'axios'
import {
  GET_DASHBOARD_COUNTS,
} from './action-constants'

const DASHBOARD_COUNTS = 'dashboard/counts'

export function getDashboardCounts (loginID) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + DASHBOARD_COUNTS + '/' + loginID
  return {
    type: GET_DASHBOARD_COUNTS,
    payload: new Promise((resolve, reject) => {
      axios
        .get(
          JSONURL
        )
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
